import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import vuetify from "@/plugins/vuetify";
import { i18n } from "@/plugins/i18n";

import { lodashPlugin } from "@/common/lodash-common";
import Axios from "@/common/axios";
Axios.init();

Vue.use(lodashPlugin);



Vue.config.productionTip = false;

require("@/scss/main.scss");


const toSnake = str => str.replace(/[A-Z]/g, (letter, index) => { return index == 0 ? letter.toLowerCase() : '_' + letter.toLowerCase(); });;
Vue.prototype["$toSnake"] = toSnake;

const mainAutoComponents = require.context("@/components/auto", true, /\.vue$/i);
for (const components of [mainAutoComponents]) {
    components.keys().map(key =>
        Vue.component(
            key
                .split("/")
                .pop()
                .split(".")[0],
            components(key).default
        )
    );
}

import { get as _get } from 'lodash'
function price(getters) {
    const price = _get(store.state.options.prices, getters)
    if (price || price === 0) return price

    console.error('Cant find price with getter ' + getters)
}
Vue.prototype["$price"] = price;

const vue = new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: (h) => h(App),
}).$mount("#app");
